import { BaseModel, ModelTemplate, ObjectTypeNum, RecursivePartial } from '@models/base';
import { NameValue } from '@models/shared/name-value';
import { VzParamConstraints } from './param-constraints';
import { VzParamStyles } from './param-styles';
import { VzParamTplvar } from './param-tplvar';
import { VzParamTrigger } from './param-trigger';
import { VzParamType } from './param-type';

export type IVzParam = ModelTemplate<VzParam>;
export class VzParam extends BaseModel {
    static Type = VzParamType;
    id?: string;
    type!: VzParamType;
    vzType?: ObjectTypeNum;
    name?: string;
    description?: string;
    defaultValue?: any;
    styles?: VzParamStyles;
    triggers?: VzParamTrigger[];
    constraints?: VzParamConstraints;
    children?: VzParam[];

    tplVars?: VzParamTplvar[];          // array of template variables for VzParamType.RichText
    baseType?: VzParam;                 // required for types Enum & Array
    objectDefs?: VzParam[];             // required for type Object
    enumDefs?: NameValue[];

    _path?: string = '';
    _enumMap?: { [value: number | string]: string };

    constructor(json?: RecursivePartial<VzParam>) {
        super(json);
        this.parseVzParam(json || {});
    }

    parse(json: RecursivePartial<VzParam>): VzParam {
        super.parse(json);
        this.parseVzParam(json);
        return this;
    }

    private parseVzParam(json: RecursivePartial<VzParam>): void {
        VzParam.assignFields<VzParam>(this, json, [
            'id',
            'type',
            'vzType',
            'defaultValue',
            'name',
            'description',
            '_path'
        ]);
        VzParam.assignClassFields<Omit<VzParam, 'defaultValue'>>(this, json, {
            constraints: VzParamConstraints,
            baseType: VzParam,
            styles: VzParamStyles
        });
        VzParam.assignClassArrays<Omit<VzParam, 'defaultValue'>>(this, json, {
            objectDefs: VzParam,
            enumDefs: NameValue,
            tplVars: VzParamTplvar,
            triggers: VzParamTrigger,
            children: VzParam
        }, { objectDefs: { _path: this._path ? this._path + '/' + this.id : this.id } });
        if (this.baseType) {
            this.baseType._path = this._path;
        }
        if (this.enumDefs) {
            this._enumMap = this.enumDefs.reduce((m, v) => ({ ...m, [v.value]: v.name }), {});
        }
        else {
            delete this._enumMap;
        }

    }

}

export const isParamValueEmpty = (value: any) => {
    return !value || ((!value.fields || !value.fields.length) && !value.field);
}
